import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useSiteContext } from '../../context/site-context';
import { useParams } from '../../../../routes/hook';
import { PostContext } from './post-context';
import { getType } from '../../../../cms-api/post';
import { getPostAdminConfig } from '../../../../cms-api/post-admin-config';
import { getPostCategoryAdminConfig } from '../../../../cms-api/post-category-admin-config';
import { getPostSummaryAdminConfig } from '../../../../cms-api/post-summary-admin-config';

export function PostProvider({ children, type }) {
  const { site, siteConfig } = useSiteContext();

  const params = useParams();
  const post_type_id = type || params.post_type_id;

  const [postType, setPostType] = useState(null);

  const [postTypeConfig, setPostTypeConfig] = useState(null);

  const [isLoading, setLoading] = useState(true);


  useEffect(() => {

    setLoading(true)

    let isDel = true;

    if (siteConfig && post_type_id) {
      getType({
        site_id: site.site_id,
        type: post_type_id,
      }).then(async (reData) => {
        const isV2 = site && !site.expand_value?.text?.private_sys_admin_config;
        let postConfig = null;

        if (isV2) {
          try {
            const v2Res = await getPostAdminConfig(site.site_id, post_type_id);
            if (v2Res && v2Res.settings) {
              postConfig = {
                id: post_type_id,
                name: reData.name,
                ...v2Res.settings
              };

              // V2 カテゴリ設定も取得
              try {
                const v2CategoryRes = await getPostCategoryAdminConfig(site.site_id, post_type_id);
                if (v2CategoryRes && v2CategoryRes.settings &&
                  v2CategoryRes.settings.view && v2CategoryRes.settings.view.length > 0) {
                  postConfig.category = {
                    post_type_id,
                    ...v2CategoryRes.settings
                  };
                }
              } catch (catErr) {
                console.error('Failed to load V2 post category config', catErr);
              }

              // V2 要約設定も取得
              try {
                const v2SummaryRes = await getPostSummaryAdminConfig(site.site_id, post_type_id);
                if (v2SummaryRes?.settings) {
                  const summarySettings = v2SummaryRes.settings;
                  if (summarySettings.summary_columns) {
                    postConfig.summary_columns = summarySettings.summary_columns;
                  }
                  if (summarySettings.summary_reflection) {
                    postConfig.summary_reflection = summarySettings.summary_reflection;
                  }
                  if (summarySettings.keywords_reflection) {
                    postConfig.keywords_reflection = summarySettings.keywords_reflection;
                  }
                }
              } catch (sumErr) {
                console.error('Failed to load V2 post summary config', sumErr);
              }
            }
          } catch (e) {
            console.error('Failed to load V2 post config', e);
          }
        } else {
          postConfig = siteConfig.posts.find((post) => post.id === post_type_id);
        }

        if (postConfig) {
          setPostType(reData)
          setPostTypeConfig(postConfig)
          isDel = false
        }

        if (isDel) {
          setPostType(null);
          setPostTypeConfig(null);
        }

        setLoading(false)
      })
    }

  }, [site, post_type_id, siteConfig, setPostType, setPostTypeConfig, setLoading]);

  const memoizedValue = useMemo(
    () => ({
      postType,
      postTypeConfig,
      postTypeIsLoading: isLoading,
    }),
    [postType, postTypeConfig, isLoading]
  );

  return (
    <PostContext.Provider value={memoizedValue}>
      {children}
    </PostContext.Provider>
  );
}

PostProvider.propTypes = {
  children: PropTypes.node,
  type: PropTypes.string,
};
